<template>
  <div class="home">
    <div class="projets conteneur">
      <div v-for="projet in projets" :key="projet" class="projet">
        <h2>{{ projet.titre }}</h2>
        <div class="info">
          <img :src="projet.url" alt="" data-aos="fade-right" />
          <div class="info__text">
            <h3>{{ projet.nom }}</h3>
            <p>{{ projet.description }}</p>
            <ul class="technos">
              <li
                v-for="technologie in projet.technologies"
                :key="technologie"
                class="techno"
              >
                <img :src="technologie" alt="" />
              </li>
            </ul>
            <a class="projet_lien" :href="projet.lien">Visiter</a>
          </div>
        </div>
      </div>
    </div>
    <div class="bleed footer">
      <div class="conteneur">
        <h2>Vous êtes un employeur?</h2>
        <router-link :to="{ name: 'Contact' }"
          >On devrais Discuter!</router-link
        >
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="../animation.js"></script>
<script>
export default {
  name: "Home",
  data() {
    return {
      projets: [
        {
          titre: "Projet Wordpress",
          nom: "Tourmaline",
          description:
            "Un projet effectué sur wordpress avec pour objectif de nous initier à l’utilisation de la plateforme. Le mandat était de créer une agence web fictive.",
          technologies: [
            require("../assets/logos/wordpress.svg"),
            require("../assets/logos/php.svg")
          ],
          url: require("../assets/projets/tourmaline.jpg"),
          lien: "https://timunix2.cegep-ste-foy.qc.ca/~tourmaline/tourmaline/"
        },
        {
          titre: "Projet Jeu",
          nom: "Beppo et les pirates de l’espace",
          description:
            "Un projet effectué en javascript dans le but d’apprendre à utiliser le javascript orienté objet avec pour mandat de créer un jeu de type shoot’em up en side scroller. ",
          technologies: [
            require("../assets/logos/js.svg"),
            require("../assets/logos/illustrator.svg"),
            require("../assets/logos/animate.svg"),
            require("../assets/logos/typescript.svg")
          ],
          url: require("../assets/projets/beppo.jpg"),
          lien:
            "https://timunix2.cegep-ste-foy.qc.ca/~edroletbegin/RPNI2/gr1_droletbegine_jeu/jeu/Beppo%20vs%20Space%20pirates/animate.html"
        },
        {
          titre: "Projet MVC",
          nom: "Traces",
          description:
            "Un projet réalisé dans le but de nous introduire à la structure MVC ainsi que le fonctionnement du e-commerce. Le mandat était de créer le site pour une librairie fictive",
          technologies: [
            require("../assets/logos/php.svg"),
            require("../assets/logos/mvc.svg"),
            require("../assets/logos/ajax.svg"),
            require("../assets/logos/sass.svg")
          ],
          url: require("../assets/projets/traces.jpg"),
          lien: "https://timunix2.cegep-ste-foy.qc.ca/~soupgang/traces/public/"
        },
        {
          titre: "Projet Wordpress",
          nom: "Tim CSF",
          description:
            "Deuxième projet réalisé sur wordpress comme synthèse. Le but était de réaliser le site web officiel du programme en toute libertée",
          technologies: [
            require("../assets/logos/wordpress.svg"),
            require("../assets/logos/php.svg"),
            require("../assets/logos/vuejs.svg"),
            require("../assets/logos/sass.svg")
          ],
          url: require("../assets/projets/timcsf.jpg"),
          lien: "https://timunix2.cegep-ste-foy.qc.ca/~edroletbegin/timcsf/"
        },
        {
          titre: "Projet Quiz",
          nom: "les Dés",
          description:
            "Un court projet réalisé en pratique pour les animations css et les transitions. Le madat était de créer un court quiz et d’en faire des animation ",
          technologies: [
            require("../assets/logos/css.svg"),
            require("../assets/logos/php.svg"),
            require("../assets/logos/jquery.svg")
          ],
          url: require("../assets/projets/des.jpg"),
          lien: "https://quiz-des.herokuapp.com/"
        },
        {
          titre: "Portfolio Vidéo",
          nom: "Mon compte viméo",
          description:
            "au cours de mes différents cours de montage, j'ai eu la chance de réaliser plusieursdifferents types de médias, animation comme montage vidéo ",
          technologies: [
            require("../assets/logos/premiere.svg"),
            require("../assets/logos/aftereffect.svg"),
            require("../assets/logos/animate.svg")
          ],
          url: require("../assets/projets/vimeo.jpg"),
          lien: "https://vimeo.com/user89251154"
        }
      ]
    };
  }
};
</script>
